type ChartSkeletonProps = {
  height?: string;
};

/**
 * Skeleton for DemandOverviewChart — two soft demand curves.
 */
export function DemandChartSkeleton({ height = "500" }: ChartSkeletonProps) {
  return (
    <div
      className="relative w-full animate-pulse overflow-hidden rounded-lg bg-gray-50"
      style={{ height: `${height}px` }}
    >
      {/* Y-axis */}
      <div className="absolute top-6 bottom-8 left-10 w-px bg-gray-200" />
      {/* X-axis */}
      <div className="absolute right-6 bottom-8 left-10 h-px bg-gray-200" />

      <svg
        className="absolute top-6 right-6 bottom-8 left-12"
        viewBox="0 0 400 200"
        preserveAspectRatio="none"
        fill="none"
      >
        {/* Smoothed demand */}
        <path
          d="M0,140 C110,90 170,150 250,110 C320,75 360,95 400,80"
          stroke="rgb(209 213 219)"
          strokeWidth="3"
          strokeLinecap="round"
        />
        {/* Raw demand (lighter, thinner) */}
        <path
          d="M0,150 C90,115 180,140 260,100 C330,68 360,92 400,88"
          stroke="rgb(229 231 235)"
          strokeWidth="2"
          strokeLinecap="round"
        />
      </svg>
    </div>
  );
}

/**
 * Skeleton for StockChart — a stock-level sawtooth (depletes through
 * consumption, then jumps up on each restock) followed by a declining forecast
 * with a confidence band that fans out from "now".
 */
export function StockChartSkeleton({ height = "500" }: ChartSkeletonProps) {
  return (
    <div
      className="relative w-full animate-pulse overflow-hidden rounded-lg bg-gray-50"
      style={{ height: `${height}px` }}
    >
      {/* Y-axis */}
      <div className="absolute top-6 bottom-8 left-10 w-px bg-gray-200" />
      {/* X-axis */}
      <div className="absolute right-6 bottom-8 left-10 h-px bg-gray-200" />

      <svg
        className="absolute top-6 right-6 bottom-8 left-12"
        viewBox="0 0 400 200"
        preserveAspectRatio="none"
        fill="none"
      >
        {/* Forecast confidence band, fanning out from "now" */}
        <path
          d="M200,120 C290,121 350,123 400,125 L400,200 C350,190 290,158 200,120 Z"
          fill="rgb(229 231 235)"
          opacity="0.5"
        />
        {/* History area — sawtooth: depletes, then jumps up on restock */}
        <path
          d="M0,40 L60,130 L62,55 L125,140 L127,50 L200,120 L200,200 L0,200 Z"
          fill="rgb(209 213 219)"
          opacity="0.35"
        />
        {/* History line */}
        <path
          d="M0,40 L60,130 L62,55 L125,140 L127,50 L200,120"
          stroke="rgb(209 213 219)"
          strokeWidth="2"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        {/* Forecast mean — declining, dashed */}
        <path
          d="M200,120 C290,143 350,156 400,165"
          stroke="rgb(209 213 219)"
          strokeWidth="2"
          strokeLinecap="round"
          strokeDasharray="6 4"
        />
      </svg>
    </div>
  );
}
